export function getFileName(url) {
    if (typeof url === 'string') {
        const arr = url.split('_')
        return arr[1] ? arr[1] : ''
    } else {
        return ''
    }
}